import * as React from 'react'
import * as styles from './style/index.scss'
import img_404 from '@assets/img/404.png'
import intl from '@utils/intl';

const ErrorC = () => (
    <div className={styles.centered}>
        <img src={img_404}/>
        <span>{intl.formatMessage({id: 'common.404'})}</span>
    </div>
)

export default ErrorC
